import type { Messages } from "../types";

export const es = {
  "common": {
    "brand": "UN8",
    "brandTag": "Citas cristianas exclusivas.",
    "continue": "Continuar",
    "leave": "Dejar",
    "leaveForNow": "dejar por ahora",
    "yes": "Sí",
    "no": "No",
    "goBack": "Volver",
    "saving": "Ahorro…",
    "submitting": "Sumisión…",
    "pleaseWait": "Espere por favor…",
    "ellipsis": "…",
    "male": "Masculino",
    "female": "Femenino",
    "phases": {
      "gate": "Puerta",
      "verify": "Verificar",
      "setup": "Configuración",
      "profile": "Perfil"
    },
    "storageQuota": "Este teléfono no tiene espacio para respuestas guardadas. Libera algo de almacenamiento y vuelve a intentarlo.",
    "storageDisabled": "Este navegador no guardará sus respuestas. Desactive el modo privado o permita los datos del sitio y luego vuelva a cargar.",
    "charMeta": "{len}/{min} mín · {current}/{max}",
    "charMetaMin": "mín {min} caracteres"
  },
  "welcome": {
    "promise": "Nuestro objetivo es que elimines esta aplicación lo más rápido posible.",
    "sub": "UN8 ayuda a solteros cristianos serios a encontrar un compañero de vida y luego irse. Verificado. Los valores primero. Sin deslizamientos interminables.",
    "signedInAs": "Iniciado sesión como {email}",
    "liveServer": "· servidor en vivo",
    "deviceOnly": "· este dispositivo sólo",
    "migrateOffer": "Este dispositivo todavía tiene un perfil local. ¿Subirlo al servidor compartido para que otros teléfonos puedan verlo después de la moderación? No se carga nada hasta que tú elijas.",
    "uploadLocalProfile": "Subir mi perfil local",
    "keepOnDevice": "Guárdalo solo en este dispositivo",
    "migrateNeedGender": "Elija primero Hombre o Mujer en su perfil.",
    "migrateDone": "Texto de perfil subido. Vuelve a subir tu identificación, video y fotos para que la moderación pueda revisarlos.",
    "deleteConfirm": "¿Eliminar permanentemente su cuenta, todos los mensajes y todos los medios (incluidos ID y videos) del servidor?",
    "accountDeleted": "Cuenta eliminada.",
    "begin": "Comenzar",
    "continueOnboarding": "Continuar incorporando",
    "logIn": "Acceso",
    "logOut": "Finalizar la sesión",
    "reviewConsole": "Consola de revisión",
    "matching": "Emparejamiento",
    "deleteMyAccount": "eliminar mi cuenta"
  },
  "faith": {
    "eyebrow": "Puerta de la fe",
    "title": "Solo cristianos",
    "text": "UN8 es una comunidad de seguidores de Jesucristo, para miembros que buscan una pareja con mentalidad matrimonial que comparta esa fe. Esta puerta no se puede saltar.",
    "yesTitle": "soy cristiano",
    "yesBody": "Sigo a Jesucristo y busco una pareja con mentalidad matrimonial que comparta esta fe.",
    "noTitle": "no soy cristiano",
    "noBody": "UN8 no es el lugar adecuado para mí, y está bien.",
    "respectTitle": "Con respecto",
    "respectBody": "UN8 está diseñado para una comunidad y preferimos ser honestos que hacerle perder el tiempo. Utilice Salir abajo o Atrás si esta no es su casa.",
    "sharedTitle": "Fundación compartida",
    "sharedBody": "La fe no es una etiqueta aquí. Es el terreno en el que os encontráis.",
    "hintNotChristian": "UN8 es para seguidores de Jesucristo. Toque Salir a continuación o elija la opción Cristiana si ese es su caso.",
    "hintUnset": "Toca \"Soy cristiano\" para continuar, o Salir/Volver si esta no es tu casa."
  },
  "rules": {
    "eyebrow": "Pacto comunitario",
    "title": "Cómo nos tratamos unos a otros",
    "text": "Afirma cada regla. Los tres son necesarios. Las violaciones conducen a la expulsión permanente. Los perfiles falsos están prohibidos para siempre.",
    "agreeContinue": "Estoy de acuerdo - continuar",
    "respectful": {
      "title": "Se respetuoso",
      "description": "Habla y actúa con dignidad. Cada persona aquí está hecha a imagen de Dios."
    },
    "noSexualContent": {
      "title": "Sin contenido sexual",
      "description": "No se permiten fotos, mensajes o solicitudes explícitas. La pureza no es opcional aquí."
    },
    "noDominance": {
      "title": "No dominar ni controlar",
      "description": "Sin coerción, manipulación o presión. El amor no controla."
    },
    "hint": "Marque las tres promesas antes de continuar."
  },
  "intent": {
    "eyebrow": "",
    "title": "¿Qué estás buscando?",
    "text": "",
    "marriage": {
      "label": "Una pareja para la vida",
      "description": ""
    },
    "discernment": {
      "label": "Matrimonio, en uno o dos años",
      "description": ""
    },
    "notCasual": {
      "label": "Primero amistad, luego vemos",
      "description": ""
    },
    "hint": "Elige una."
  },
  "account": {
    "eyebrow": "Cuenta",
    "title": "Crea tu acceso",
    "text": "Su identificador crea una identificación de usuario estable. La aplicación, la verificación, los me gusta y las coincidencias se vinculan a esa identificación. No se envía ningún correo electrónico.",
    "recoveryTitle": "Guarde su código de recuperación",
    "recoveryText": "Mostrado una vez. Sin él, una frase de contraseña perdida no se puede restablecer en esta prueba cerrada.",
    "savedContinue": "Lo he guardado - continuar",
    "handle": "Manejar",
    "handlePlaceholder": "tú@ejemplo.com o un identificador corto",
    "passphrase": "frase de contraseña",
    "passphrasePlaceholder": "Al menos 8 caracteres",
    "signedInTitle": "Iniciado sesión",
    "signedInBody": "{email} · {userId}",
    "trustTitle": "Estándar de confianza",
    "trustBody": "Ningún perfil será visible hasta que se complete la verificación de identidad y la moderación lo apruebe.",
    "continueToVerification": "Continuar con la verificación",
    "hintEmail": "Escriba una dirección de correo electrónico que incluya @.",
    "hintPassword": "Elija una contraseña de al menos 8 caracteres."
  },
  "verify": {
    "intro": {
      "eyebrow": "Verificación",
      "title": "La confianza es la puerta",
      "text": "Cargue una identificación gubernamental, un video de confirmación y fotos reales {min}–{max}. Todo entra en una cola de revisión antes de que pueda aparecer su perfil.",
      "whyTitle": "Por qué verificamos",
      "whyBody": "La pesca del gato y las verdades a medias no tienen cabida aquí. Los perfiles falsos están prohibidos permanentemente. Los medios se almacenan con el estado pending_review hasta que se aprueben.",
      "start": "Iniciar verificación"
    },
    "steps": {
      "id": {
        "title": "Identificación gubernamental",
        "description": "Pasaporte o DNI: carga de cámara o archivo."
      },
      "video": {
        "title": "Vídeo de confirmación",
        "description": "Una breve grabación que demuestra que estás presente."
      },
      "photos": {
        "title": "Fotos reales",
        "description": "De siete a diez fotografías claras tuyas."
      },
      "review": {
        "title": "Revisión de integridad",
        "description": "Las cargas permanecen pending_review hasta que el personal las confirme."
      }
    },
    "id": {
      "eyebrow": "Paso 1 de 4",
      "title": "Identificación gubernamental",
      "text": "Capture o cargue su pasaporte o documento nacional de identidad. No se publica nada: el estado permanece pending_review hasta que el personal lo confirme.",
      "savedTitle": "ID guardada",
      "savedBody": "Lo siguiente es un breve video de confirmación de tu rostro, luego de 7 a 10 fotos reales tuyas. Continuar se desbloquea cuando esta identificación se muestra guardada.",
      "hint": "Tome o cargue una foto de su identificación gubernamental, luego espere hasta que diga guardado."
    },
    "video": {
      "eyebrow": "Paso 2 de 4",
      "title": "Vídeo de confirmación",
      "text": "Graba un clip corto o sube uno. Mira hacia la cámara. Habla claramente. Esto demuestra que estás presente, no en una galería raspada.",
      "hint": "Graba un breve vídeo de confirmación y espera hasta que diga guardado."
    },
    "photos": {
      "eyebrow": "Paso 3 de 4",
      "title": "Fotos reales",
      "text": "Agregue {min}–10 fotos recientes suyas. Utilice la cámara o su biblioteca. Toque × para eliminar cualquier toma.",
      "continueToReview": "Continuar revisando",
      "hint": "Agrega {min} a 10 fotografías claras tuyas. Continuar desbloquea cuando se guardan."
    },
    "review": {
      "eyebrow": "Paso 4 de 4",
      "title": "Revisión de integridad",
      "text": "Los medios están en cola como pending_review{underUser}. Las coincidencias y los me gusta utilizarán la misma identificación.",
      "underUser": "bajo el usuario {userId}",
      "governmentId": "Identificación gubernamental",
      "confirmationVideo": "Vídeo de confirmación",
      "photos": "Fotos",
      "missing": "Desaparecido",
      "filesReady": "Archivos {count} listos",
      "submittedTitle": "Enviado para revisión",
      "submittedText": "La identificación de la aplicación es igual a la identificación del usuario de autenticación, por lo que aprobar → el grupo y los me gusta mutuos permanecen alineados.",
      "submitContinue": "Enviar y continuar"
    }
  },
  "setup": {
    "eyebrow": "Configuración de cuenta",
    "title": "Di la verdad sobre ti mismo",
    "text": "Estas respuestas dan forma a la coincidencia y aparecen en la revisión. Las mentiras suaves hacen perder el tiempo a todos, incluido el suyo.",
    "beginSetup": "Comenzar la configuración",
    "pillars": {
      "faith": {
        "name": "Fe",
        "text": "Por qué sigues a Cristo."
      },
      "character": {
        "name": "Personaje",
        "text": "Lealtad, honestidad, pasión, compromiso: calificación del 1 al 10."
      },
      "story": {
        "name": "Historia",
        "text": "Quién eres y qué buscas."
      },
      "life": {
        "name": "Vida",
        "text": "Hobby, lectura y vocación."
      }
    },
    "whyChristian": {
      "eyebrow": "Fe",
      "title": "¿Por qué eres cristiano?",
      "text": "Una respuesta breve y honesta. No es un sermón, una razón que es tuya.",
      "label": "Tu respuesta",
      "placeholder": "p.ej. Conocí a Cristo en una época de pérdida y lo he seguido desde...",
      "hint": "Escribe al menos caracteres {min} sobre por qué sigues a Jesús."
    }
  },
  "scales": {
    "eyebrow": "Escalas de personajes",
    "title": "Califícate honestamente",
    "text": "Lealtad, honestidad, pasión, compromiso, cada uno del 1 al 10. Inflar los números solo hará que no coincidan más adelante. Debes configurar cada escala para continuar.",
    "loyalty": {
      "label": "Nivel de lealtad",
      "hint": "Sea honesto: ¿con qué fidelidad apoya a sus seres queridos?"
    },
    "honesty": {
      "label": "nivel de honestidad",
      "hint": "¿Con qué consistencia dices toda la verdad?"
    },
    "passion": {
      "label": "¿Qué tan apasionado eres?",
      "hint": "Convicción y profundidad, no desempeño."
    },
    "commitment": {
      "label": "Nivel de compromiso",
      "hint": "¿Qué tan preparado estás para construir algo que dure?"
    },
    "hint": "Mueva cada control deslizante para que se muestre un número; ninguno puede permanecer como un guión."
  },
  "about": {
    "eyebrow": "Acerca de ti",
    "title": "Descríbete a ti mismo en unas pocas frases.",
    "text": "Quién eres cuando nadie actúa. Temperamento, ritmo, lo que importa el día a día.",
    "label": "Acerca de ti",
    "placeholder": "Mañanas tranquilas, serios con la familia, reír con facilidad, preferir la profundidad al ruido…",
    "hint": "Escribe al menos caracteres {min} sobre ti."
  },
  "looking": {
    "eyebrow": "Pareja",
    "title": "¿Qué estás buscando?",
    "text": "Los rasgos de carácter principal que deseas en una pareja potencial, no una lista de looks de compras.",
    "label": "Rasgos de carácter deseados",
    "placeholder": "p.ej. Fe firme, madurez emocional, bondad bajo estrés…",
    "hint": "Escribe al menos caracteres {min} sobre la pareja que esperas."
  },
  "loveReady": {
    "eyebrow": "Límite",
    "title": "¿Estás listo para conocer al amor de tu vida?",
    "text": "UN8 existe para que los solteros serios busquen pareja y luego eliminen la aplicación. Sólo continúan los desbloqueos \"Sí\".",
    "yesTitle": "Sí, estoy listo",
    "yesBody": "Estoy aquí para encontrarme con mi persona con claridad y valentía.",
    "noTitle": "Aún no",
    "noBody": "Si solo estás navegando, esta comunidad no es la adecuada.",
    "comeBackTitle": "Vuelve cuando esté listo",
    "comeBackBody": "UN8 es para personas dispuestas a reunirse, no a recopilar opciones. Utilice Dejar a continuación si desea detenerse por ahora. Sus respuestas se guardan en este teléfono.",
    "hintNo": "Sólo continúa el “Sí”. Si no está listo, toque Salir por ahora; sus respuestas permanecen en este teléfono.",
    "hintUnset": "Toque Sí si está listo para conocer a alguien para casarse."
  },
  "lifestyle": {
    "eyebrow": "Estilo de vida",
    "title": "Como vives el dia a dia",
    "text": "Deportes, aficiones, lectura y profesión: señales prácticas para una verdadera compatibilidad.",
    "hobbies": "Deportes o pasatiempos actuales.",
    "hobbiesPlaceholder": "Lo que haces activamente, no lo que solías hacer una vez.",
    "reading": "¿Lees?",
    "readingHint": "1 = casi nunca · 10 = lectura profunda diaria",
    "profession": "Profesión / sector",
    "professionPlaceholder": "p.ej. Enfermería · Software · Educación · Oficios",
    "hintHobbies": "Nombra al menos un deporte o pasatiempo que realmente practiques.",
    "hintReading": "Deslice “¿Lees?” entonces se muestra un número del 1 al 10.",
    "hintProfession": "Escribe el trabajo que haces, aunque sea una palabra corta."
  },
  "faithDepth": {
    "eyebrow": "Coincidencia · Fe",
    "title": "¿Qué tan central es tu fe?",
    "text": "Servir a Dios: ¿qué importancia tiene en tu vida? Responde honestamente. Matching usa esto para profundidad, no para rendimiento.",
    "serving": "Servir a Dios: importancia",
    "servingHint": "10%… 100%. Deslice en pasos de 10.",
    "keepsCommandments": "¿Guardas los mandamientos?",
    "grewUpInChurch": "¿Creciste en la iglesia?",
    "churchAttendance": "Asistencia a la iglesia",
    "frequent": {
      "label": "Frecuente",
      "hint": "Reunión regular con el cuerpo de Cristo."
    },
    "seldom": {
      "label": "Rara vez",
      "hint": "En ocasiones, no hay un ritmo semanal."
    },
    "never": {
      "label": "Nunca",
      "hint": "Actualmente no asiste."
    },
    "spreadsGospel": "¿Difundes el evangelio?",
    "hasIdols": "¿Tienes ídolos?",
    "hintServing": "Desliza lo importante que es servir a Dios en tu vida.",
    "hintCommandments": "Responde si guardas los mandamientos: Sí o No.",
    "hintGrewUp": "Responde si creciste en la iglesia: Sí o No.",
    "hintAttendance": "Elige con qué frecuencia asistes a la iglesia.",
    "hintGospel": "Responda si comparte el evangelio: Sí o No.",
    "hintIdols": "Responde si tienes ídolos: Sí o No."
  },
  "character": {
    "eyebrow": "Coincidencia · Personaje",
    "title": "quien eres en casa",
    "text": "Carácter para el cortejo: pacificación, modales, honestidad. Inflar las respuestas solo hará que no coincidan más adelante.",
    "peacemaker": "¿Eres un pacificador?",
    "homebuilder": "¿Es usted un constructor de viviendas?",
    "humorous": "¿Eres gracioso?",
    "caring": "¿Cuidadoso y afectuoso?",
    "peacefulHome": "¿Quieres un hogar pacífico y libre de peleas?",
    "manners": "¿Buenas maneras?",
    "honestyRating": "Calificación de honestidad en este cuestionario.",
    "honestyHint": "1–10: ¿con qué honestidad respondes?",
    "hintPeacemaker": "Responda cada Sí o No, comenzando con pacificador.",
    "hintHomebuilder": "Responda si es constructor de viviendas.",
    "hintHumorous": "Responde si eres gracioso.",
    "hintCaring": "Responde si eres cariñoso y afectuoso.",
    "hintPeaceful": "Responde si quieres un hogar tranquilo.",
    "hintManners": "Responde si tienes buenos modales.",
    "hintHonesty": "Desliza tu calificación de honestidad del 1 al 10."
  },
  "history": {
    "eyebrow": "Coincidencia · Historia",
    "title": "Pasado y preparación",
    "text": "Sustancias, infancia, cicatrices y si estás preparado para una relación duradera. La verdad aquí los protege a ambos.",
    "marijuana": "¿Has consumido marihuana?",
    "lsd": "¿Has usado LSD?",
    "otherDrugs": "¿Has usado otras drogas?",
    "addicted": "¿Has sido adicto?",
    "childhood": "¿Infancia estable y amorosa?",
    "scars": "¿Alguna cicatriz/dañado?",
    "lasting": "¿Listo para una relación duradera?",
    "hintStart": "Responda cada Sí o No en esta página, comenzando desde arriba.",
    "hintLsd": "Responda la pregunta sobre el LSD: Sí o No.",
    "hintOtherDrugs": "Responda si ha consumido otras drogas.",
    "hintAddicted": "Responde si has sido adicto.",
    "hintChildhood": "Responde si tu infancia fue estable y amorosa.",
    "hintScars": "Responde si tienes cicatrices.",
    "hintLasting": "Responde si estás preparado para una relación duradera."
  },
  "appearance": {
    "eyebrow": "Coincidencia · Apariencia",
    "title": "Tatuajes",
    "text": "Tus tatuajes y si los tatuajes en tu pareja son aceptables para ti.",
    "hasTattoos": "¿Tienes tatuajes?",
    "acceptsPartner": "¿Aceptar tatuajes en pareja?",
    "hintHas": "Di si tienes tatuajes: sí o no.",
    "hintAccepts": "Diga si le parecen aceptables los tatuajes en su pareja."
  },
  "home": {
    "eyebrow": "Coincidencia · Hogar y tierra",
    "title": "Tierra, habilidades, autosuficiencia",
    "text": "Hierbas, cultivo de alimentos, bosque frutal, preparación, agricultura comunitaria, conservación, supervivencia y cualquier habilidad especial.",
    "herbKnowledge": "¿Conocimientos sobre hierbas?",
    "plantOwn": "¿Plantas tus propias frutas y verduras?",
    "fruitForest": "¿Interesado en un bosque frutal?",
    "prepping": "¿Preparándose para las calamidades?",
    "communityFarming": "¿Agricultura comunitaria/vida independiente?",
    "canning": "¿Enlatar y conservar?",
    "survival": "¿Habilidades de supervivencia?",
    "specialSkills": "Habilidades especiales (opcional)",
    "specialPlaceholder": "Cualquier otra cosa que traigas a un hogar o terreno...",
    "hintStart": "Responda cada Sí o No sobre terrenos y habilidades, comenzando desde arriba.",
    "hintPlant": "Responde si plantas tus propias frutas y verduras.",
    "hintFruitForest": "Responde si te interesa un bosque frutal.",
    "hintPrepping": "Responde si te preparas para las calamidades.",
    "hintCommunity": "Responda si le interesa la agricultura comunitaria.",
    "hintCanning": "Responde si puedes y conserva los alimentos.",
    "hintSurvival": "Responde si tienes habilidades de supervivencia."
  },
  "family": {
    "eyebrow": "Coincidencia · Familia",
    "title": "Niños, profundidad de fe, sustancias.",
    "text": "Lo que necesita en una pareja sobre la intensidad de la fe, los hijos y el uso de sustancias en el pasado.",
    "children": "Niños",
    "wants": {
      "label": "quiere hijos",
      "hint": "Construir una familia es parte de la visión."
    },
    "doesNotWant": {
      "label": "no quiere hijos",
      "hint": "Claro no a los niños."
    },
    "open": {
      "label": "Abierto",
      "hint": "Discernido, no bloqueado en ningún sentido."
    },
    "hasLivingWith": {
      "label": "Tiene hijos – vive con ellos",
      "hint": "Los niños ya son parte de la vida diaria."
    },
    "requiredFaith": "Nivel mínimo de fe que necesitas en una pareja",
    "requiredFaithHint": "10%… 100%. Puerta dura cuando ambas partes han respondido.",
    "acceptsSubstances": "¿Aceptar el uso de sustancias en el pasado en una pareja?",
    "hintChildren": "Elija una tarjeta sobre niños.",
    "hintFaith": "Desliza el nivel mínimo de fe que esperas en una pareja.",
    "hintSubstances": "Diga si el consumo de sustancias en el pasado por parte de su pareja es aceptable."
  },
  "ancestry": {
    "eyebrow": "Coincidencia · Fondo",
    "title": "Preferencias de fondo",
    "text": "Comparta sus antecedentes y lo que está dispuesto a hacer en una pareja. Esto solo da forma a la clasificación; nunca oculta a alguien del mazo.",
    "yourBackground": "Tu experiencia (selecciona todo lo que corresponda)",
    "openToPartner": "Abierto a un socio",
    "codeDesc": "Código: {code}",
    "anyDesc": "Mayor preferencia por la amplitud: recomendado cuando no está seguro.",
    "preferenceOnly": "Sólo preferencia, no una puerta de entrada.",
    "hintOwn": "Marca al menos un entorno que te describa. Esto sólo ayuda a clasificar, nunca oculta a nadie.",
    "hintAccepted": "Marque lo que está dispuesto a aceptar en una pareja o \"Abierto, sin preferencia\"."
  },
  "interests": {
    "eyebrow": "Coincidencia · Intereses",
    "title": "lo que disfrutas",
    "text": "Elige al menos uno. La superposición ayuda a clasificar; El silencio nunca es castigado.",
    "hint": "Marque al menos un interés."
  },
  "reflection": {
    "eyebrow": "Coincidencia · Reflexión",
    "title": "En tus propias palabras",
    "text": "Estas cuatro respuestas se muestran completas y nunca se califican. Escribe lo que es verdad.",
    "describeYourself": "Descríbete a ti mismo",
    "lifePurpose": "propósito de vida",
    "fifteenYear": "Tú y el amor de tu vida en 15 años.",
    "weaknesses": "Debilidades",
    "hintDescribe": "Descríbete al menos con caracteres {min}.",
    "hintPurpose": "Escribe el propósito de tu vida en al menos caracteres {min}.",
    "hintVision": "Escriba la visión de 15 años al menos en caracteres {min}.",
    "hintWeaknesses": "Nombra una debilidad en al menos caracteres {min}."
  },
  "profile": {
    "eyebrow": "Perfil",
    "title": "Algunos elementos esenciales",
    "text": "Mantenlo simple. El sexo aquí es binario (masculino o femenino) para una correspondencia clara.",
    "firstName": "Nombre de pila",
    "firstNamePlaceholder": "Como deseas ser conocido",
    "age": "Edad",
    "agePlaceholder": "18+",
    "city": "Ciudad",
    "cityPlaceholder": "donde estas basado",
    "sex": "Sexo",
    "maleBody": "Soy un hombre.",
    "femaleBody": "Soy una mujer.",
    "hintName": "Escriba su nombre (al menos dos letras).",
    "hintAge": "La edad debe ser mayor de 18 años.",
    "hintCity": "Escribe la ciudad donde vives.",
    "hintGender": "Elija Hombre o Mujer para que la combinación funcione."
  },
  "ready": {
    "title": "Puedes entrar.",
    "textNamed": "{name}, su verificación y configuración quedan registradas. El medio es pending_review. Bienvenido a UN8: busque a su persona y luego elimine la aplicación.",
    "text": "Su verificación y configuración quedan registradas. El medio es pending_review. Bienvenido a UN8: busque a su persona y luego elimine la aplicación.",
    "summaryAria": "Resumen de configuración",
    "christianRules": "Reglas cristianas afirmadas",
    "mediaLine": "ID · vídeo · {photoCount} fotos · cola {pending}",
    "scalesLine": "Balanzas L{loyalty}/H{honesty}/P{passion}/C{commitment}",
    "genderProfession": "{gender} · {profession}",
    "sexUnset": "Sexo -",
    "professionFallback": "profesión",
    "userLine": "Usuario {userId}",
    "enterMatching": "Introduzca la coincidencia",
    "needGender": "Vuelve al paso del perfil y elige Hombre o Mujer, luego inténtalo de nuevo."
  },
  "match": {
    "brandTag": "Emparejamiento",
    "navOnboarding": "Incorporación",
    "navReview": "Revisar",
    "navMatching": "Emparejamiento",
    "logOut": "Finalizar la sesión",
    "quietSignIn": "Acceder",
    "enterTitle": "Introduzca la coincidencia",
    "enterText": "Inicie sesión con el mismo correo electrónico de incorporación. La aplicación, el grupo, los me gusta y las coincidencias utilizan su identificación de usuario estable.",
    "email": "Correo electrónico",
    "emailPlaceholder": "tu@ejemplo.com",
    "password": "Contraseña",
    "passwordPlaceholder": "Tu contraseña",
    "logIn": "Acceso",
    "guestOr": "O pruebe una sesión de invitado (identificación estable por navegador · solo demostración)",
    "guestMan": "Invitado como hombre",
    "guestWoman": "Invitada como mujer",
    "goOnboarding": "Ir a incorporación →",
    "guestSession": "Sesión de invitado · grupo de demostración",
    "man": "hombre",
    "woman": "mujer",
    "tabToday": "Selección",
    "tabMatches": "Coincidencias ({count})",
    "yourMatches": "Tus coincidencias",
    "matchesSub": "Interés mutuo persistente · {count} saliente {likesWord}",
    "like": "como",
    "likes": "gustos",
    "emptyMatches": "Aún no hay interés mutuo. Sigue discerniendo la selección de esta semana.",
    "valuesScore": "Valores {score}",
    "chatOpen": "· Chat abierto",
    "tapToChat": "· Toca para chatear",
    "personLine": "{name}, {age}",
    "cityValues": "{city} · Valores {score}",
    "noProfileYet": "Aún no hay perfil",
    "noProfileText": "Termine la incorporación o toque Incorporación en la parte superior y luego Comenzar. La coincidencia de invitados está en la pantalla de entrada si solo quieres mirar.",
    "matchingPaused": "Coincidencia pausada",
    "noOneYet": "Nadie para mostrar todavía",
    "todaysSetDone": "Esa es la selección de esta semana",
    "emptyNeverHad": "No hay nadie en la selección de esta semana. Si acaba de terminar de incorporarse, es posible que el grupo en vivo aún esté vacío; pruebe con una sesión de invitado para ver a las personas de demostración o regrese después de que se aprueben más miembros.",
    "emptyDone": "Has repasado la selección de esta semana. Vuelve la próxima semana o reinicia el mazo para mirar de nuevo.",
    "likesMayNotStick": "Es posible que los Me gusta no se mantengan.",
    "poolMeta": "Grupo: {pool} · Coincidencias: {matches} · Me gustó: {liked}",
    "demoPool": "manifestación",
    "livePool": "{source} ({count})",
    "resetDeck": "Reiniciar plataforma",
    "backOnboarding": "Volver a la incorporación",
    "feedEyebrowDemo": "Selección semanal · Demo pool",
    "feedEyebrowLive": "Selección semanal · Pool ({source}, {count})",
    "feedTitle": "Discernir con cuidado",
    "left": "quedan {count}",
    "pass": "Aprobar",
    "interested": "Interesado",
    "likeHeart": "♥ Me gusta",
    "flame": "🔥 Llama",
    "flameNoneLeft": "No te queda llama esta semana. Vuelve el lunes.",
    "flameLead": "Te gusta de verdad {name}. Escribe algo — o sáltalo.",
    "flameOnly": "Solo llama",
    "flameSend": "Enviar llama con esto",
    "flameBurstTitle": "Una llama para {name}",
    "flameSent": "Le enviaste una llama a {name}.",
    "heartsNoneLeft": "No te quedan corazones esta semana. Vuelven el lunes.",
    "commentLead": "Dile una cosa a {name}. Diez palabras.",
    "commentPlaceholder": "Diez palabras, no más",
    "commentCount": "{count} / {max}",
    "commentSend": "Enviar corazón con esto",
    "heartOnly": "Solo corazón",
    "commentTooLong": "Son más de {max} palabras. El corazón se envió; la nota no.",
    "commentAnchors": {
      "about": "Sobre mí",
      "lookingFor": "Busco",
      "hobbies": "Intereses",
      "photo": "Foto"
    },
    "inboundTitle": "Le gustaste",
    "likeBack": "Devolver like",
    "swipeHint": "Desliza o usa los botones. Una coincidencia se abre sólo cuando el interés es mutuo y persistente.",
    "celebrationEyebrow": "Interés mutuo",
    "celebrationTitle": "tu coincidiste",
    "celebrationText": "{self} · {other}",
    "celebrationNote": "",
    "matchingScore": "Puntuación de coincidencia",
    "goToProfile": "Ver perfil",
    "goToProfileChat": "Perfil y chat",
    "holdToPeek": "Mantén la carta de {name} para ver datos",
    "holdOrOpenProfile": "Mantén para datos, toca para el perfil de {name}",
    "likeToOpenProfile": "Dale like para abrir su perfil completo",
    "waitLikeBack": "Esperando que {name} te corresponda — entonces se abre el chat.",
    "affinity": "Puntuación de coincidencia",
    "valuesScoreLabel": "Puntuación de coincidencia",
    "openChat": "abrir chat",
    "keepDiscerning": "Sigue discerniendo",
    "cardSeeking": "Buscando",
    "cardHobbies": "Pasatiempos",
    "scoreStrong": "Fuerte alineación",
    "scoreSolid": "Alineación sólida",
    "scoreModerate": "Alineación moderada",
    "scoreDifferent": "Diferentes ritmos",
    "characterAxisFoot": "El eje del carácter incluye los cuatro pilares.",
    "youThem": "Tú {self} · Ellos {other}",
    "stampInterest": "Interés",
    "stampPass": "Aprobar",
    "explainLegacyClose": "Sus puntuaciones de valores se encuentran muy juntas ({score} de 100).",
    "explainLegacyFuller": "Aparece un \"por qué\" más completo después de que ambos terminen las preguntas coincidentes.",
    "explainFaith": "La intensidad de tu fe es cercana: tomas el seguimiento de Jesús con la misma seriedad.",
    "explainCharacter": "La forma en que tratas a las personas en casa se alinea: paz, modales y atención.",
    "explainPurpose": "Calificaste tu propia honestidad de manera similar, lo cual es un signo de seriedad compartida.",
    "explainHome": "Comparten el interés por la tierra, el cultivo de alimentos o una casa autosuficiente.",
    "explainAncestry": "Ambos prefieren antecedentes familiares similares. Esto es una preferencia, no un filtro: nadie se esconde de ello.",
    "explainTemperament": "Tus intereses y temperamento se superponen.",
    "explainFallback": "Existe una posible coincidencia en las respuestas que ambos completaron.",
    "explainOverall": "Puntuación de coincidencia {score}/100",
    "affinityAxes": {
      "faith": "Intensidad de la fe",
      "character": "Carácter y conducta",
      "purpose": "Alineación del propósito de vida",
      "home": "Hogar y autosuficiencia",
      "ancestry": "Afinidad cultural y de origen",
      "temperament": "Ajuste de temperamento"
    },
    "scaleAxes": {
      "loyalty": "Lealtad",
      "honesty": "Honestidad",
      "passion": "Pasión",
      "commitment": "Compromiso"
    },
    "weeklyTitle": "Tus 4 de esta semana",
    "weeklyTitleCount": "Tus {count} de esta semana",
    "weeklyCountdown": "Próxima selección en {days} días",
    "weeklyCountdownOne": "Próxima selección en 1 día",
    "weeklyCountdownSoon": "Próxima selección pronto",
    "shortWeekCopy": "Esta semana hay {count}. Nunca sugerimos a alguien que no encaje.",
    "shortWeekTwo": "Esta semana hay dos. Nunca sugerimos a alguien que no encaje.",
    "weekDone": "Esa es la selección de esta semana",
    "weekDoneText": "Has discernido a todos los que pudimos sugerir con honestidad. Vuelve cuando se abra la próxima selección.",
    "waitingModeration": "Tu perfil espera la aprobación de moderación antes de que se abra la selección.",
    "completeProfileFirst": "Completa tu perfil y envíalo primero.",
    "moderationDemoNote": "Mostramos personas de demostración para que puedas probar el emparejamiento.",
    "navSelection": "Selección",
    "navMessages": "Mensajes",
    "navProfile": "Perfil",
    "packTitle": "Tus cuatro",
    "packSkip": "Toca para continuar",
    "refreshTitle": "Nueva selección",
    "newSelection": "Nueva selección",
    "backToFour": "← Volver a tus cuatro",
    "whoLikedTitle": "A quién le gustas",
    "whoLikedEmpty": "Nadie nuevo te ha dado me gusta todavía.",
    "whoLikedLocked": "Suscríbete para ver nombres en la selección semanal — los corazones entrantes siguen en Mensajes.",
    "verify": {
      "brandTag": "Verificar",
      "title": "Verifícate para escribir",
      "sub": "Cualquiera puede mirar y dar corazón. Para conversar hacen falta tu identificación y un vídeo corto de confirmación. Con enviarlo basta: la revisión puede esperar.",
      "cta": "Añadir identificación y vídeo",
      "videoCta": "Añadir un vídeo de confirmación",
      "submitted": "Identificación y vídeo recibidos. Puedes escribir mientras revisamos.",
      "done": "Estás verificado.",
      "back": "Atrás",
      "continue": "Continuar",
      "idEyebrow": "Identidad",
      "videoEyebrow": "Presencia",
      "idText": "Pasaporte o documento nacional. No se publica nada. Con enviarlo basta para poder escribir.",
      "videoText": "Un clip corto (unos {seconds} segundos). Mira a la cámara. Esto demuestra que estás presente."
    }
  },
  "chat": {
    "brandTag": "Charlar",
    "unavailableTitle": "Chat no disponible",
    "unavailableText": "Esta coincidencia falta o no pertenece a tu sesión.",
    "backToMatches": "Volver a coincidencias",
    "backMatches": "← Coincidencias",
    "valuesSubscriber": "Valores {score} · Suscriptor",
    "valuesTrial": "Valores {score} · Prueba",
    "valuesKept": "Valores {score} · Coincidencia conservada",
    "empty": "Saluda con cuidado. En el backend compartido, los mensajes se sincronizan con ambos teléfonos después de una coincidencia mutua.",
    "placeholder": "Mensaje {name}…",
    "ariaMessage": "Mensaje",
    "send": "Enviar"
  },
  "billing": {
    "paywallCopy": "Después de tu prueba gratuita, mantén a todas las personas con las que ya has coincidido y sigue chateando. Para ver gente nueva, suscríbete.",
    "signInToMatch": "Inicie sesión para utilizar la coincidencia.",
    "signInFirst": "Inicia sesión primero.",
    "subscriberUntil": "Suscriptor · hasta {date}",
    "renewal": "renovación",
    "freeTrial": "Prueba gratuita · {days} días (finaliza {date})",
    "soon": "pronto",
    "trialEnded": "Prueba finalizada; las coincidencias y el chat permanecen abiertos",
    "subscribe": "Suscríbete · ${price}/mes",
    "subscribeEarly": "Suscríbete temprano · ${price}/mes",
    "activeNote": "Suscripción activa: puedes volver a ver gente nueva.",
    "playOnly": "La suscripción es solo mediante Google Play Billing (instalación de la app). No hay pago web aquí.",
    "playOnlyShort": "Facturación solo por Google Play — sin pago web."
  },
  "auth": {
    "recoveryTitle": "Guarde su código de recuperación",
    "recoveryText": "Escribe esto ahora. Se muestra una vez. Si pierde su frase de contraseña, este código es la única forma de restablecerla en la prueba cerrada.",
    "savedContinue": "Lo he guardado - continuar",
    "welcomeBack": "Bienvenido de nuevo",
    "createAccount": "Crea tu cuenta",
    "intro": "Identificador y frase de contraseña. No se envía ningún correo electrónico ni SMS. Su identificación se mantiene estable durante la incorporación, la revisión y la comparación.",
    "tabLogin": "Acceso",
    "tabRegister": "Registro",
    "handle": "Manejar",
    "handlePlaceholder": "tú@ejemplo.com o un identificador corto",
    "passphrase": "frase de contraseña",
    "passphrasePlaceholder": "Al menos 8 caracteres",
    "submitLogin": "Acceso",
    "submitRegister": "Crear una cuenta",
    "backWelcome": "volver a dar la bienvenida"
  },
  "options": {
    "origin": {
      "african": "africano",
      "european": "europeo",
      "asian": "asiático",
      "latino": "Latino / Hispano",
      "middleEastern": "Medio Oriente",
      "indigenous": "Indígena",
      "mixed": "Mezclado",
      "other": "Otro",
      "dutch": "Holandés",
      "german": "Alemán",
      "any": "Abierto: sin preferencia"
    },
    "interest": {
      "prayer": "Oración",
      "worship": "Culto",
      "reading": "Lectura",
      "hiking": "Senderismo",
      "music": "Música",
      "cooking": "Cocinando",
      "farming": "Agricultura / jardinería",
      "sports": "Deportes",
      "missions": "Misiones",
      "family": "vida familiar",
      "crafts": "Artesanía",
      "outdoors": "Al aire libre"
    }
  },
  "capture": {
    "yesNoDefaults": {
      "yes": "Sí",
      "no": "No"
    },
    "id": {
      "titleEmpty": "Identificación gubernamental",
      "titleReady": "ID listo",
      "hintEmpty": "Pasaporte o DNI. Tome una foto en vivo o elija una imagen/PDF. Las cuatro esquinas visibles.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "savedSuffix": "· guardado",
      "previewAlt": "Vista previa de identificación gubernamental",
      "pdfAria": "Documento PDF seleccionado",
      "takePhoto": "tomar foto",
      "retake": "Volver a tomar",
      "chooseFile": "Elige el archivo",
      "replaceFile": "Reemplazar archivo",
      "remove": "Eliminar",
      "uploading": "Subiendo…",
      "cameraTitle": "Fotografíe su identificación",
      "signIn": "Inicie sesión antes de cargar la identificación.",
      "uploadFailed": "La carga falló. Intentar otra vez.",
      "badFile": "No se pudo utilizar este archivo."
    },
    "video": {
      "titleEmpty": "Vídeo de confirmación",
      "titleLive": "camara en vivo",
      "titleReady": "Vídeo listo",
      "hintEmpty": "Di tu nombre y que te unes a UN8 honestamente. 5 a 15 segundos.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "rec": "REC {seconds}s",
      "record": "Registro",
      "cameraUpload": "Subir cámara",
      "chooseFile": "Elige el archivo",
      "startRecording": "Empezar a grabar",
      "cancel": "Cancelar",
      "stopSave": "Detener y guardar",
      "recordAgain": "Grabar de nuevo",
      "replaceFile": "Reemplazar archivo",
      "remove": "Eliminar",
      "unsupported": "La grabación en vivo no está disponible aquí. Utilice la carga de la cámara o elija un archivo.",
      "permissionDenied": "Permiso de cámara denegado. Aún puedes subir un archivo de vídeo corto.",
      "signIn": "Inicia sesión antes de subir el vídeo.",
      "uploadFailed": "La carga falló. Intentar otra vez.",
      "saveFailed": "No se pudo guardar la grabación.",
      "badVideo": "No se pudo utilizar este vídeo."
    },
    "photos": {
      "count": "Fotos de {count} / {max}",
      "minimumMet": "Mínimo cumplido",
      "moreRequired": "{n} se requiere más",
      "listAria": "Fotos de verificación",
      "photoAlt": "Foto {n}",
      "removeAria": "Eliminar foto {n}",
      "camera": "Cámara",
      "takePhoto": "tomar foto",
      "chooseFiles": "Elige archivos",
      "uploading": "Subiendo…",
      "hint": "Tomar foto abre la cámara en vivo. Elegir archivos es solo para selecciones de galería. Tomas faciales claras: sin filtros que oculten la identidad. Máx. {max}.",
      "cameraTitle": "Toma una foto tuya",
      "signIn": "Inicia sesión antes de subir fotos.",
      "someFailed": "Algunas fotos no se pudieron cargar. Vuelva a intentar los que fallaron.",
      "addFailed": "No se pudieron agregar fotos."
    },
    "liveStill": {
      "titleDefault": "Cámara",
      "close": "Cerca",
      "capture": "Captura",
      "cancel": "Cancelar",
      "hint": "Mantente firme. La cámara en vivo permanece abierta hasta que captures.",
      "unavailable": "La cámara no está disponible en este navegador. Utilice Elegir archivo en su lugar.",
      "permissionDenied": "Permiso de cámara denegado o no disponible. Utilice Elegir archivo en su lugar.",
      "frameFailed": "No se pudo capturar este fotograma.",
      "saveFailed": "No se pudo guardar la foto."
    },
    "uploadStatus": {
      "uploading": "subiendo…",
      "failed": "la carga falló",
      "savedLocally": "guardado localmente",
      "uploaded": "subido",
      "stored": "almacenado",
      "awaitingUpload": "Esperando carga",
      "localFallbackNote": "El archivo {error} se guarda en este dispositivo; Vuelva a intentarlo cuando el punto final de la señal esté activo."
    }
  },
  "language": {
    "label": "Idioma",
    "choose": "Elige idioma"
  },
  "shell": {
    "back": "Atrás",
    "goBackAria": "Volver"
  },
  "questionnaire": {
    "skipForNow": "Omitir por ahora",
    "skipConsequence": "Los perfiles respondidos se muestran primero.",
    "confirm": "Continuar",
    "progressLabel": "{current} de {total}",
    "fewSentences": "Algunas oraciones",
    "ancestryNote": "Esto es una preferencia que solo afecta el orden — nunca oculta a nadie."
  }
} as Messages;
